// extracted by mini-css-extract-plugin
module.exports = {"buildingContainer":"SitePreview_buildingContainer__250Oo","buildingText":"SitePreview_buildingText__3xQ28","buildingAction":"SitePreview_buildingAction__SbGuG"};